/* tslint:disable */
/* eslint-disable */
/**
 * Legalscape REST API
 * Internal API for use from web
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * W&Hのモデルの選択肢
 * @export
 * @enum {string}
 */

export const LabsWandhModelSelectionEnum = {
    Standard: 'standard',
    Advanced: 'advanced',
    DeepResearch: 'deep-research'
} as const;

export type LabsWandhModelSelectionEnum = typeof LabsWandhModelSelectionEnum[keyof typeof LabsWandhModelSelectionEnum];



